import { render } from "./InwoodActivities.vue?vue&type=template&id=3c039ebc"
import script from "./InwoodActivities.vue?vue&type=script&lang=js"
export * from "./InwoodActivities.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp\\www\\GuideParis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__